import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './App.css';
import {HeroUIProvider} from "@heroui/system";
import { Toaster } from "react-hot-toast";

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <main className="custom-theme text-foreground bg-background">
      <HeroUIProvider>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                position: 'relative',
                zIndex: 10002, // Ensure it's globally above everything
              },
            }}
          />
          <App />
      </HeroUIProvider>
    </main>
  </React.StrictMode>,
); 